import React, { FunctionComponent, useContext } from 'react'
import styles from './GalleryDesktop.module.sass'
import { FileData } from '../../../../../responses/files'
import CloseIcon from 'files/close.svg'
import ChevronLeftIcon from 'files/chevron/left.svg'
import ChevronRightIcon from 'files/chevron/right.svg'
import DownloadIcon from 'files/download.svg'
import DeleteIcon from 'files/delete.svg'
import { useRootDispatch } from '../../../../../utils/hooks'
import { galleryActions, GalleryData } from '../../../../../redux/global/gallery/gallery-actions'
import { isSome } from 'fp-ts/Option'
import { useKeyPressEvent } from 'react-use'
import fileSize from 'filesize'
import Button from 'ts/components/controls/Button/Button'
import { urlWithParams } from '../../../../../http/utils'
import { ROUTES } from '../../../../../http/routes'
import { RequestStatus } from '../../../../../responses/response'
import Skeleton from 'react-loading-skeleton'
import { statusContext } from '../../../../../constants/contexts'
import GalleryPreview from '../GalleryPreview/GalleryPreview'
import GalleryComments from '../GalleryComments/GalleryComments'
import GalleryHeader from '../GalleryHeader/GalleryHeader'
import Aside from '../../../Aside/Aside'
import { Colors } from '../../../../../styles'
import { GalleryNavigation } from '../../navigation'

interface Props {
    current: FileData | null,
    data: GalleryData,
    navigation: GalleryNavigation,
    onPrev: () => void,
    onNext: () => void,
    onClose: () => void,
    onDelete: () => void,
}

const GalleryDesktop: FunctionComponent<Props> = props => {
    const dispatch = useRootDispatch()

    const status = useContext(statusContext)

    useKeyPressEvent('ArrowLeft', () => {
        isSome(props.navigation.prev) && dispatch(galleryActions.setCurrent(props.navigation.prev.value))
    })

    useKeyPressEvent('ArrowRight', () => {
        isSome(props.navigation.next) && dispatch(galleryActions.setCurrent(props.navigation.next.value))
    })

    useKeyPressEvent('Escape', () => {
        dispatch(galleryActions.close())
    })

    return <div className={styles.container}>
        <GalleryHeader className={styles.header} data={props.data}>
            <div className={styles.close} onClick={props.onClose}>
                <CloseIcon/>
                <div className={styles.text}>{'Закрыть <Esc>'}</div>
            </div>
        </GalleryHeader>
        {
            isSome(props.navigation.prev) && <div
                className={styles.backward}
                onClick={props.onPrev}
            >
                <ChevronLeftIcon/>
            </div>
        }
        {
            isSome(props.navigation.next) && <div
                className={styles.forward}
                onClick={props.onNext}
            >
                <ChevronRightIcon/>
            </div>
        }
        {
            props.current ? <div className={styles.main}>
                <GalleryPreview className={styles.content} current={props.current}/>
                    <div className={styles.bottom}>
                        <div className={styles.info}>
                            <div className={styles.name}>{props.current.name}</div>
                            <div className={styles.size}>{fileSize(props.current.size)}</div>
                        </div>
                        <div className={styles.actions}>
                            <a
                                download
                                href={urlWithParams({filename: props.current.filename})(ROUTES.FILE_ORIGINAL)}
                            >
                                <Button
                                    // todo решить с исключением
                                    color={Colors.white}
                                    // intent={Intent.DARK}
                                    title={'Скачать файл'}
                                >
                                    <DownloadIcon/>
                                </Button>
                            </a>
                            {
                                !props.current.deleted && <Button
                                    title={'Удалить файл'}
                                    color={Colors.white}
                                    // todo решить с исключением
                                    // intent={Intent.DARK}
                                    onClick={props.onDelete}
                                >
                                    <DeleteIcon/>
                                </Button>
                            }
                        </div>
                    </div>
                </div> :
                <div className={styles.placeholder}>
                    {
                        status === RequestStatus.FETCHING ?
                            <Skeleton height={100} width={100}/>:
                            <div className={styles.error}>Галерея пуста</div>
                    }
                </div>
        }
        <Aside className={styles.aside}>
            <GalleryComments className={styles.list} data={props.data}/>
        </Aside>
    </div>
}

export default GalleryDesktop